import * as React from 'react';

//hook
import { useState } from 'react';
import { UserConsumer } from '../hooks/context/UserContext';
import { useApi } from '../hooks/useApi';

//type
import { ForgetPassowrdReqType } from '../api/forget&resetPassword/type/ForgetAndResetPassword';

//api
import { PostResetPasswordApi } from '../api/forget&resetPassword/PostResetPasswordApi';

//mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

//mui icon
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Country Piker  Library
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//formik and yap
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

//image
import login_logo from '../assets/login/login_logo.png'

//device token
import { requestNotificationPermission } from '../firebase/notifgicationFireBase';

//react router dom
import { useNavigate } from 'react-router-dom';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface ResetPasswordProps {
  openResetPassword: boolean,
  setOpenResetPassword: (open: boolean) =>void
}

const ResetPassword = ({openResetPassword, setOpenResetPassword}: ResetPasswordProps) => {
    const {t} = useTranslation()
    const [showPass, setShowPass] = useState<boolean>(false)
    const navigate = useNavigate();
    const ForgetPasswordSchema = Yup.object().shape({
        phone: Yup.string()
        //test(name, message, testFunction)
        .test(
            "len",t("phone_lenght"),
            (value) => {
            if (!value) return false;
            const numberWithoutCode = value.slice(4);
            return numberWithoutCode.length == 9 && !numberWithoutCode.startsWith("0") ;
            }
        ).required(t("phone_required")),
        password: Yup.string().min(6, t("password_min")).required(t("password_required")),
        otp: Yup.string().min(5, t("otp_min")).required(t("otp_required")),
        
    });
    const {
        loading: reserPasswordLoading,
        error: reserPasswordError,
        HandlerApi: reserPasswordApi
    } = useApi(PostResetPasswordApi, "POST");
      let {setUserData} = UserConsumer()
    const handleClose = () => {
        setOpenResetPassword(false);
    };
    const handleSubmit = async (values: ForgetPassowrdReqType)=> {
        const deviceToken = await requestNotificationPermission().then((token) => token);
        const payload = {
        ...values,
        device_token: deviceToken,
        device_type: "web",
        };
        console.log(payload)
        const result = await reserPasswordApi(payload);
        localStorage.setItem("token", result.data.token);
        console.log('password reseted successful:');
        navigate("/")
        setUserData(result.data)
        handleClose();
    }
    return (
    <div>
        <Dialog 
        open={openResetPassword}
        onClose={handleClose}
        slots={{
        transition: Transition,
        }}
        disableRestoreFocus
        >
            <DialogTitle className='flex gap-3'>
            <img className='w-[30px] h-[30px]' src={login_logo} alt='no=photo'/>
            <p>{t("gettak")}</p>
            </DialogTitle>
            <div className='flex justify-between max-sm:flex-col pb-5'>
            <div className='w-full'>
                <DialogTitle>
                <p className='text-[12px] text-darkColor'>{t("please_enter_new_password_and_otp")}</p>
                </DialogTitle>
                <DialogContent>
                <Formik
                initialValues={{phone: '', password: "", otp: ""}}
                validationSchema={ForgetPasswordSchema}
                onSubmit={(values)=>handleSubmit(values)}
                disableRestoreFocus
                maxWidth="md"
                fullWidth
                >
                    {({ values,touched, errors,setFieldValue }) => (
                        <Form>
                        <div className="mt-5">
                            <PhoneInput
                            country={"sy"}
                            onlyCountries={["sy"]}
                            disableDropdown={true}
                            enableSearch={true}
                            value={values.phone}
                            onChange={(phone) => setFieldValue("phone", phone.startsWith("+") ? phone : `+${phone}`)}
                            inputStyle={{
                                borderRadius: "4px",
                                width: "100%",
                                height: "56px",
                                border: touched.phone && errors.phone ? "1px solid red" : "",
                            }}
                            buttonStyle={{ marginRight: "8px", direction: "ltr" }}
                            containerStyle={{
                                display: "flex",
                                flexDirection: i18n.language === "ar" ? "row-reverse" : undefined,
                            }}
                            inputProps={{
                                autoComplete: "phone",
                            }}
                            />
                            <div className="text-red-500 text-sm mt-1">
                            {touched.phone && errors.phone ? errors.phone : ""}
                            </div>
                            <Field
                                as={TextField}
                                name="password"
                                type={showPass ? "text" : "password"}
                                label={t("password")}
                                className="w-full !mt-5"
                                autoComplete="password"
                                helperText={touched.password && errors.password ? errors.password : ""}
                                error={touched.password && Boolean(errors.password)}
                                InputProps={{
                                endAdornment: (
                                    <IconButton onClick={()=>setShowPass((prev)=>!prev)}>
                                        {showPass ? <Visibility/> : <VisibilityOff/>}
                                    </IconButton>
                                ),
                                }}
                            />
                            <Field
                                as={TextField}
                                name="otp"
                                type="number"
                                label={t("otp")}
                                className="w-full !mt-5"
                                helperText={touched.otp && errors.otp ? errors.otp : ""}
                                error={touched.otp && Boolean(errors.otp)}
                            />
                        </div>
                        <DialogActions className={i18n.language === "en" ? "!justify-start" : "!justify-start"}>
                            <Button className='w-full h-[62px] !bg-customerColor !text-white !rounded-full' type="submit">
                            {reserPasswordLoading 
                            ? <CircularProgress className='w-1 h-1'/>
                            :t("confirm")
                            }
                            </Button>
                        </DialogActions>
                        </Form>
                    )}
                </Formik>
                </DialogContent>
            </div>
            </div>
        </Dialog>
    </div>
    )
}

export default ResetPassword